import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { VideoPlayerProvider } from "./contexts/VideoPlayerContext";
import { FavoritesProvider } from "./contexts/FavoritesContext";
import { SportsDataProvider } from "./contexts/SportsDataContext";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Header from "./components/Header";
import VideoPlayer from "./components/VideoPlayer";
import NewsTicker from "./components/NewsTicker";
import MobileNav from "./components/MobileNav";
import AuthCallback from "./components/AuthCallback";
import Dashboard from "./pages/Dashboard";
import LeagueHub from "./pages/LeagueHub";
import GameDetail from "./pages/GameDetail";
import TeamProfile from "./pages/TeamProfile";
import "./App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Header />
      <main className="pb-36 sm:pb-32">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/league/:leagueKey" element={<LeagueHub />} />
          <Route path="/game/:leagueKey/:eventId" element={<GameDetail />} />
          <Route path="/team/:leagueKey/:teamId" element={<TeamProfile />} />
        </Routes>
      </main>
      <VideoPlayer />
      <NewsTicker />
      <MobileNav />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <VideoPlayerProvider>
          <FavoritesProvider>
            <SportsDataProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </SportsDataProvider>
          </FavoritesProvider>
        </VideoPlayerProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
